module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Cuwignaka and I Will Go to the Draw")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Help me,\" said Wasnapohdi, \"please.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We helped her put the huge bull on his belly in the grass, pulling the legs out. Cows, which are lighter, are usually skinned on their sides, and then turned, sometimes by ropes tied to their legs, drawn by the kaiila.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wasnapohdi thrust her knife in behind the neck, to make the first slash, from which the skin would begin to be folded back, to expose the forequarters on each side. Subsequently the hide, in the normal fashion, can be cut down the middle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The liver had already been removed from the animal, by the hunters. It is a great delicacy, and is commonly eaten raw.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How is Winyela doing?\" I asked. I saw the girl to the side on the grass, kneeling, her head down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is sick,\" said Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I walked over to the girl. It did not smell too nicely near her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How are you feeling?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am all right,\" she said. \"In a little while I will try to cut the meat again.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are a female, Winyela,\" said Wasnapohdi, sweating, working. \"You must learn this.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I will try again, in a little bit,\" said Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There is a cow over there,\" said Wasnapohdi, kneeling on the back of the animal, pointing with the bloody knife, \"felled by one of Canka's arrows. I will have her work on her. That way, if she does poorly, since it is his own kill, and not that of another, he can be more lenient with her.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you think he will be lenient?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said Wasnapohdi, returning to her task.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not afraid,\" said Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" she said. \"No matter what I do, I know that Canka will never punish me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why is that?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He likes me,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And do you like him?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I love him,\" she said, \"dearly, more than anything.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Bold slave,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"A slave may be bold,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is true,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Nonetheless,\" said Wasnapohdi, grunting, at her work, \"do not be surprised if you find yourself well quirted.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka would never do that to me,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Have you never brought him the quirt?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Once,\" she said, \"the first evening in his lodge, he made me bring him the quirt, on my hands and knees, in my teeth.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What do you suppose the meaning of that was?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That I was a slave, that I was subject to discipline,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And do you think he will have forgotten that?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I suppose not,\" she said. \"But he did not use it on me, not then, nor has he used it on me later.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka,\" she said, \"will never punish me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled. I did not think the girl understood, fully, that she was a slave. Did she not know that, as a slave, she was subject to discipline, and that any master, regardless of his feelings, would impose it on her? The domination of slaves is not a haphazard or tentative thing. They are owned. They will serve, perfectly. If they do not, they will be punished, severely, or, if the master wishes, slain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps I am too pretty to whip,\" said Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I would not count on it,\" said Wasnapohdi, irritatedly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"At any rate,\" said Winyela, \"Canka, I think, likes me. He will never beat me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Say that again,\" said Wasnapohdi, pausing in her work, breathing heavily, \"when you find yourself on your knees, stripped, your wrists bound before you, to the whipping stake, every inch of your body bared to the stroke of his quirt.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are so silly!\" laughed Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Help me put the meat I am cutting on the travois,\" said Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Must I touch it?\" asked Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not really wish to do so,\" said Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe Canka will not beat you,\" said Wasnapohdi, \"but I assure you that I would have no compunction in doing so. Hurry now! Get busy, or I will take a bone and lash the hide off your pretty rump.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sometimes,\" said Winyela to me, getting to her feet, \"Wasnapohdi is vulgar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you obey?\" inquired Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I obey,\" said Winyela, loftily, tossing her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Put your head down, and say that, humbly,\" said Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I obey,\" said Winyela, her head down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"More humbly,\" said Wasnapohdi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I obey,\" said Winyela, more humbly, half sobbing, putting her head down further.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good,\" said Wasnapohdi. \"Now, come here.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wasnapohdi thrust eight or ten pounds of bloody meat into the unwilling hands of Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Later,\" said Wasnapohdi, \"you will cut up that cow over there. I will show you how.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That will not be necessary,\" said Winyela. \"I have seen how it is done.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winyela then turned about and carried the meat to the travois. I took some from Wasnapohdi and carried it, too, to their travois.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not be a little fool,\" I said to her, at the travois. \"Let Wasnapohdi help you. She is your friend.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I can do it myself,\" said Winyela. \"And if I do not do it well, it does not matter.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not be too sure of that,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka would never strike me,\" she said. \"Too, he will do whatever I want.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not forget,\" I said, \"who is the master, and who is the slave.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In the lodge of Canka,\" she said, \"I can do whatever I please.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps he will find it necessary to remind you that you are a slave,\" I said, \"that you must obey, and be pleasing, perfectly, in all respects.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps,\" she laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps you wish to be reminded that you are a slave,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is absurd,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you know that you are a slave?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I know it,\" she said, \"of course.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But do you know it in the heart, and in the heat and humility of you?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked at me, puzzled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you know it in the deepest love of you?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not understand,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is where you want to know it,\" I told her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not understand,\" she said, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Beware,\" I said, \"lest your secret dream come true.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka will never beat me,\" she said. Then she drew the hide cover over the meat, to protect it from the flies.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked about. From where we stood I could see at least a dozen fallen animals, their bulk, like dark mounds, dotting the plains. Too, here and there, we could see women, with their kaiila and travois, working, or moving about.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cuwignaka and I must get back to work,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I wish you well, Slave,\" said she.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I wish you well, too, Slave,\" I said. I then went to join Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka will never beat me,\" she called after me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps not,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Come, Winyela,\" called Wasnapohdi. \"There is meat to put on the travois.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am coming,\" responded Winyela.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My, there is a pretty girl,\" said Bloketu, the daughter of Watonka, the chief of the Isanna Kaiila. \"But why is she wearing the dress of a white woman?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps she is a white female slave,\" said Iwoso.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Greetings, Bloketu. Greetings, Iwoso,\" said Cuwignaka, grinning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You have cut a great deal of meat,\" said Bloketu, honestly observing this.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We have already made four trips back to the village,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I noted that both Bloketu and Iwoso were suitably impressed with this.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How many trips have you made?\" asked Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"One,\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I was not surprised. We had seen more than one hunter, later in the afternoon, drift back to visit with her. Bloketu was a beauty, and the daughter of a chieftain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Iwoso is slow,\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not slow,\" protested Iwoso.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is you who are lazy and slow, Bloketu,\" said Cuwignaka. \"It is well known. You would rather primp, and pose and smile for the hunters than do your work.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh!\" cried Bloketu. Iwoso, her head down, smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is not enough to be merely beautiful,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"At least you think I am beautiful,\" said Bloketu, somewhat mollified.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is not enough,\" said Cuwignaka. \"If you were my woman, you would be worked well. If you did not work well I would beat you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I suppose,\" she said, \"you think you could work me well.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cuwignaka. \"I would work you well, both outside the lodge and, even better, within it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh!\" said Bloketu, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am the daughter of a chieftain,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are only a female,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Come, Iwoso, my dear maiden,\" said Bloketu, \"let us go. We do not need to stay here, to listen to the prattle of this silly girl in the dress of a white woman.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You might make an excellent slave, Bloketu,\" said Cuwignaka. \"It might be pleasant to put you in a collar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Iwoso looked up, suddenly, her eyes blazing. Then she put her head down. I did not understand this reaction on her part.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, oh!\" said Bloketu, speechless with rage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hold,\" I said to Cuwignaka. \"It is Hci.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riding up, now, coming through the tall grass, was the young Sleen Soldier, the son of Mahpiyasapa, the chieftain of the Isbu. \"You are too close to the herd,\" said Hci. I doubted that this was true, from the tremors in the earth, the dust and the direction of the tracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I have been insulted, Hci,\" said Bloketu, complaining to the young man. She pointed to Cuwignaka. \"Punish him!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Her?\" asked Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Her!\" said Bloketu, returning to the tribally prescribed feminine gender for Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What did she say?\" asked Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She said that I was lazy and slow!\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh?\" asked Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And that he could work me in his lodge, and well!\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes?\" asked Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Too, he said that I might make an excellent slave, and that it might be pleasant to put me in a collar!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hci looked Bloketu over, slowly. She shrank back, abashed. Cuwignaka's assessment, it seemed clear, was one for which he thought there was much to be said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Please, Hci,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He then turned his attention to the lovely Iwoso. \"She should not be wearing leggings,\" he said to Bloketu. \"Too, her dress is too long. It should come high on her thighs.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is only my maiden,\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where is her collar?\" asked Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not put her in one,\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is no longer a child,\" said Hci. \"She is a grown woman now. She is old enough, now, for the garb and collar of a slave. She is old enough, now, for a warrior.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Iwoso looked down, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yellow-Knife woman,\" said Hci, bitterly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked up at him, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"A Yellow Knife did this to me,\" said Hci, pointing to the long, jagged scar at his chin, on the left side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He struck you well!\" said Iwoso, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I slew him,\" said Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hci then again turned his attention to Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Punish him,\" said Bloketu, pointing to Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Her?\" said Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Her!\" said Bloketu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am a warrior,\" said Hci. \"I do not mix in the squabbles of females.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh,\" cried Bloketu, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled to myself. It seemed to me that Hci had handled this business well. Surely it would have been beneath his dignity to meddle in such a business. Too, as a Sleen Soldier, on the day of a hunt, during their tenure of power, he had matters much more important to attend to than the assuagement of a female's offended vanity.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The herd is too close,\" said Hci. \"You are all to withdraw from this place.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We prepared to turn about.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Separately,\" said Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hair rose again on the back of my neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There,\" said Hci, pointing to the southwest, \"is a fallen bull, a Cracked-Horns, of thirty winters.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That is not good meat, or good hide,\" said Bloketu, puzzled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Attend to it, Bloketu,\" said Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Hci,\" she said. The two women, then, Bloketu and Iwoso, the travois poles marking the grass behind their kaiila, took their way away. I watched the grass springing up behind them. In a few minutes it would be difficult for anyone but a skilled tracker, looking for broken stems, to determine that they had gone that way.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Over there,\" said Hci, to us, pointing east by southeast, \"there is a draw. In the draw there is a fallen bull, a Smooth Horns, no more than some six winters in age. Attend to it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Hci,\" said Cuwignaka, obediently. A Smooth Horns is a young, prime bull. Its horns are not yet cracked from fighting and age. The smoothness of the horns, incidentally, is not a purely natural phenomenon. The bulls polish them, themselves, rubbing them against sloping banks and trees. Sometimes they will even paw down earth from the upper sides of washouts and then use the harder, exposed material beneath, dust scattering about, as a polishing surface. This polishing apparently has the function of both cleaning and sharpening the horns, two processes useful in intraspecific aggression, the latter process improving their capacity as fighting instruments, in slashing and goring, and the former process tending to reduce the amount of infection in a herd resulting from such combats. Polishing behavior in males thus appears to be selected for. It has consequences, at any rate, which seem to be in the best interests of the kailiauk as a species.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There,\" said Hci, \"your kaiila will be tired. Unharness them from the travois. Let them graze. Picket them close to where you are working.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cuwignaka, angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Go now,\" said Hci, pointing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Hci,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I was sweating, as the young Sleen Soldier rode away. \"What was that all about?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"This meat on our travois,\" said Cuwignaka, \"is to be destroyed.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not understand,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We will go to the draw,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Very well,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea39274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 81
// module chunks = 0